var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webix-ui',{attrs:{"config":_vm.config},model:{value:(_vm.session_data),callback:function ($$v) {_vm.session_data=$$v},expression:"session_data"}}),_c('div',{attrs:{"id":"sessionsPaging"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }